"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NDescriptor__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "baseURI",
                type: "string",
            },
        ],
        name: "BaseURIUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "DataURIToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "PartsLocked",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_beard",
                type: "bytes",
            },
        ],
        name: "addBeard",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_cheeks",
                type: "bytes",
            },
        ],
        name: "addCheeks",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_color",
                type: "string",
            },
        ],
        name: "addColorToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_ears",
                type: "bytes",
            },
        ],
        name: "addEars",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_emotion",
                type: "bytes",
            },
        ],
        name: "addEmotion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_eyes",
                type: "bytes",
            },
        ],
        name: "addEyes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_face",
                type: "bytes",
            },
        ],
        name: "addFace",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_glasses",
                type: "bytes",
            },
        ],
        name: "addGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_goggles",
                type: "bytes",
            },
        ],
        name: "addGoggles",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_hair",
                type: "bytes",
            },
        ],
        name: "addHair",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_hat",
                type: "bytes",
            },
        ],
        name: "addHat",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_helmet",
                type: "bytes",
            },
        ],
        name: "addHelmet",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_lips",
                type: "bytes",
            },
        ],
        name: "addLips",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_beards",
                type: "bytes[]",
            },
        ],
        name: "addManyBeards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_cheekses",
                type: "bytes[]",
            },
        ],
        name: "addManyCheekses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string[]",
                name: "newColors",
                type: "string[]",
            },
        ],
        name: "addManyColorsToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_earses",
                type: "bytes[]",
            },
        ],
        name: "addManyEarses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_emotions",
                type: "bytes[]",
            },
        ],
        name: "addManyEmotions",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_eyeses",
                type: "bytes[]",
            },
        ],
        name: "addManyEyeses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_faces",
                type: "bytes[]",
            },
        ],
        name: "addManyFaces",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_glasseses",
                type: "bytes[]",
            },
        ],
        name: "addManyGlasseses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_goggleses",
                type: "bytes[]",
            },
        ],
        name: "addManyGoggleses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_hairs",
                type: "bytes[]",
            },
        ],
        name: "addManyHairs",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_hats",
                type: "bytes[]",
            },
        ],
        name: "addManyHats",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_helmets",
                type: "bytes[]",
            },
        ],
        name: "addManyHelmets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_lipses",
                type: "bytes[]",
            },
        ],
        name: "addManyLipses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_mouths",
                type: "bytes[]",
            },
        ],
        name: "addManyMouths",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_necks",
                type: "bytes[]",
            },
        ],
        name: "addManyNecks",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_noses",
                type: "bytes[]",
            },
        ],
        name: "addManyNoses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_punkTypes",
                type: "bytes[]",
            },
        ],
        name: "addManyPunkTypes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_teeths",
                type: "bytes[]",
            },
        ],
        name: "addManyTeeths",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_mouth",
                type: "bytes",
            },
        ],
        name: "addMouth",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_neck",
                type: "bytes",
            },
        ],
        name: "addNeck",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_nose",
                type: "bytes",
            },
        ],
        name: "addNose",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_punkType",
                type: "bytes",
            },
        ],
        name: "addPunkType",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_teeth",
                type: "bytes",
            },
        ],
        name: "addTeeth",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "arePartsLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "beardCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "beards",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cheeksCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "cheekses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct ISeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "earsCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "earses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "emotionCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "emotions",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "eyesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "eyeses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "faceCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "faces",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct ISeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "generateSVGImage",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct ISeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "genericDataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "glassesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "glasseses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gogglesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "goggleses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hairCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "hairs",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hatCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "hats",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "helmetCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "helmets",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDataURIEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lipsCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "lipses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockParts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "mouthCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "mouths",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "neckCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "necks",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "noseCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "noses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "palettes",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "punkTypeCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "punkTypes",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "teethCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "teeths",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDataURIEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct ISeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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$e1d8844a0810dc0e87a665b1f2b5fa7c69$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$e1d8844a0810dc0e87a665b1f2b5fa7c69$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
class NDescriptor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, NDescriptor__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$e1d8844a0810dc0e87a665b1f2b5fa7c69\\$__", "g"), linkLibraryAddresses["contracts/libs/NFTDescriptor.sol:NFTDescriptor"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NDescriptor__factory = NDescriptor__factory;
NDescriptor__factory.bytecode = _bytecode;
NDescriptor__factory.abi = _abi;
